import { createContext, useEffect, useRef, useState } from "react";
import { enTexts } from "./texts/en";
import client from "./contentfulClient";
import { smoothScrollTo } from "./components/smoothScroll";

const texts_raw = {
    En: enTexts,
};

export const MainContext = createContext();

const languages = ["En", "Ru", "Am"];

export const MainContextProvider = ({ children }) => {
    const [lang, setLang] = useState("Am");
    const [staticTexts, setStaticTexts] = useState({
        lingustic: {},
        translation: {},
        polygraph: {},
        voice: {},
        courses: {},
        aboutUs: {},
        learnMoreButton: {},
        contactUsButton: {},
        menuLatestPost: {},
        menuTranslationService: {},
        menuOurService: {},
        menuPhonoscopy: {},
        menuEducationalCourses: {},
        menuLinguisticExpertise: {},
        menuOurTeam: {},
        menuAboutUs: {},
        latestPostTitle: {},
        translationTitle: {},
        servicesTitle: {}
    });
    const [posts, setPosts] = useState([]);
    const [linguisticServices, setLinguisticServices] = useState([]);
    const [translators, setTranslators] = useState([]);
    const [polygraphTypes, setPolygraphTypes] = useState([]);
    const [analysisServices, setAnalysisServices] = useState([]);
    const [heading, setHeading] = useState({});
    const [courses, setCourses] = useState([]);
    const [imageUrls, setImageUrls] = useState([]);
    const [team, setTeam] = useState([])
    const aboutUsRef = useRef([]);
    const headingRef = useRef(null);
    const wrapperRef = useRef(null);
    const cardRefs = useRef([]);
    const translationRef = useRef([]);
    const polygraphTypesRef = useRef([]);
    const analysisServicesRef = useRef([]);
    const languageCoursesRef = useRef([]);
    const [modal, setModal] = useState(null);

    const handleScroll = (targetRef) => {
        if (targetRef.current) {
            smoothScrollTo(targetRef.current.length ? targetRef.current[0] : targetRef.current, 1000, 300);
        }
    };

    const getFields = (e, id, contentId) => {
        let init_fields = [];
        if (id) {
            init_fields.push(e.items.find((item) => item.sys.id === id)?.fields);
        } else if (contentId) {
            e.items.map((item) => {
                if (item.sys.contentType.sys.id === contentId) {
                    init_fields.push(item.fields);
                }
            });
        }
        const fields = [];
        init_fields.map((init_field) => {
            let mini_field = {};
            Object.keys(init_field).forEach((f) => {
                if (f.endsWith(lang) || languages.map((l) => !f.endsWith(l)).filter((e) => e).length === languages.length) {
                    if (typeof init_field[f] === "string") {
                        mini_field[f.slice(0, -2)] = init_field[f];
                    } else if (init_field[f].nodeType == "document") {
                        mini_field[f.slice(0, -2)] = init_field[f].content[0].content[0].value;
                    } else if (init_field[f]?.fields?.file?.url) {
                        mini_field[f] = `https:${init_field[f].fields.file.url}`;
                    }
                }
            });
            fields.push(mini_field);
        });
        if (id) {
            return fields[0];
        } else {
            return fields;
        }
    };

    console.log(team)
    const updateAll = async () => {
        const e = await client.getEntries();
        const images = await client.getAssets();
        setImageUrls(images.items.map((e) => `https:${e.fields.file.url}`));
        setStaticTexts({
            translation: getFields(e, "5Kx2KWGitZnVqDdyqjiWIR"),
            lingustic: getFields(e, "1etuLAIbEztxB9hkulw8Zt"),
            polygraph: getFields(e, "9Zif1wIM0o21Ke7EUvJIC"),
            voice: getFields(e, "7zBJ5YNbaykyGY4fgr5i2m"),
            courses: getFields(e, "Df690CqyjBOqdRiaB1Sik"),
            aboutUs: getFields(e, "5lNPTm4d4nJO1dWPqIphB3"),
            learnMoreButton: getFields(e, "6vo5LaWi9dZokZQJXGtefy"),
            contactUsButton: getFields(e, "71RR7tfx2Xr0KzaIgEJtHN"),
            menuEducationalCourses: getFields(e, "7LQVhjM9z3kAImSOQGzZMt"),
            menuPhonoscopy: getFields(e, "6K1bTub3X19Tnb95Py9sti"),
            menuOurService: getFields(e, "72T5714A9A5oczsUwM4vTg"),
            menuTranslationService: getFields(e, "7njGEJJwx830WbopwZdwHQ"),
            menuLinguisticExpertise: getFields(e, "70vte2BnQCpeu7SU0rSBSC"),
            menuLatestPost: getFields(e, "5aXtHMda8CmDlBQjr2vB6E"),
            menuOurTeam: getFields(e, "6wsmrrGSmqn5X9mfZ0WCJF"),
            menuAboutUs: getFields(e, "1d6lYnldLfaP2lvOWF9Ido"),
            latestPostTitle: getFields(e, "5JFWhmaFDBm7UC2uvHXWiu"),
            translationTitle: getFields(e, "79HVFLOCT2lR9IRcTsxA7M"),
            servicesTitle: getFields(e, "37vWuHWt7gCXbV01GQQny5"),
        });

        setHeading(getFields(e, "0W6JXLjJp78EuRMPYlblK"));
        setPosts(getFields(e, null, "post"));
        setLinguisticServices(getFields(e, null, "linguisticService"));
        setTranslators(getFields(e, null, "translationTypes"));
        setPolygraphTypes(getFields(e, null, "polygraphService"));
        setAnalysisServices(getFields(e, null, "phonoscopyType"));
        setCourses(getFields(e, null, "courses"));
        setTeam(getFields(e, null, "team"))
    };

    useEffect(() => {
        updateAll();
    }, [lang]);

    const openModal = ({ title, subTitle, text, image, type }) => {
        console.log(type)
        setModal({ title, subTitle, text, image, type });
    };

    const closeModal = () => {
        setModal(null);
    };

    return (
        <MainContext.Provider
            value={{
                setLang,
                staticTexts,
                courses,
                analysisServices,
                translators,
                polygraphTypes,
                linguisticServices,
                heading,
                posts,
                updateAll,
                texts: texts_raw["En"],
                handleScroll,
                aboutUsRef,
                headingRef,
                wrapperRef,
                cardRefs,
                translationRef,
                polygraphTypesRef,
                analysisServicesRef,
                languageCoursesRef,
                imageUrls,
                team,
                openModal,
                closeModal,
                modal,
                lang,
            }}
        >
            {children}
        </MainContext.Provider>
    );
};
